/** Debounce before PUT /api/settings/preferences (shared by app + E2E). */
export const PREFERENCES_SAVE_DEBOUNCE_MS = 400;
